import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaHome, FaSearch } from 'react-icons/fa';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found - EduConsult</title>
      </Helmet>

      <section className="min-h-screen flex items-center justify-center hero-pattern">
        <div className="container-custom">
          <div className="max-w-2xl mx-auto text-center">
            {/* 404 Number */}
            <h1 className="text-9xl md:text-[200px] font-bold gradient-text mb-6">
              404
            </h1>
            
            <h2 className="text-3xl md:text-4xl font-display font-bold text-gray-900 mb-4">
              Page Not Found
            </h2>
            
            <p className="text-lg text-gray-600 mb-8">
              Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
            </p>

            <div className="flex flex-wrap gap-4 justify-center">
              <Link to="/" className="btn btn-primary inline-flex items-center">
                <FaHome className="mr-2" />
                Go to Homepage
              </Link>
              <Link to="/colleges" className="btn btn-secondary inline-flex items-center">
                <FaSearch className="mr-2" />
                Browse Colleges
              </Link>
            </div>

            {/* Helpful Links */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-600 mb-4">Quick Links:</p>
              <div className="flex flex-wrap gap-4 justify-center text-sm">
                <Link to="/about" className="text-primary-600 hover:underline">
                  About Us
                </Link>
                <Link to="/colleges" className="text-primary-600 hover:underline">
                  Colleges
                </Link>
                <Link to="/blogs" className="text-primary-600 hover:underline">
                  Blog
                </Link>
                <Link to="/contact" className="text-primary-600 hover:underline">
                  Contact Us
                </Link>
                <Link to="/register" className="text-primary-600 hover:underline">
                  Register
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
